<template>
    <div>
        <div id="container">
            <baidu-map class="map" :center="map.center" :zoom="map.zoom" v-if="navigatorInfo != null" @ready="handler">
                <!--缩放-->
                <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
                <!--定位-->
                <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
                <!--点-->
                <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">
                <!--提示信息-->
                <bm-info-window :show="map.show">Hello~</bm-info-window>
                </bm-marker>
            </baidu-map>
        </div>
    </div>
</template>
 
<script>
export default {
  name: "ShopNavigator",
  data: () => ({
    navigatorInfo: null,
  }),
  methods: {
    handler({ BMap, map }) {
      let me = this;
      console.log(BMap, map);
      // 鼠标缩放
      map.enableScrollWheelZoom(true);
      // 点击事件获取经纬度
      map.addEventListener("click", function (e) {
        console.log(e.point.lng, e.point.lat);
      });
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
      } else {
        this.navigatorInfo = "Geolocation is not supported by this browser.";
      }
    },
    showPosition(position) {
        console.log("浏览器坐标:" + position);
        console.log(position);
        this.navigatorInfo = position;
    },
  },
  computed: {
    map() {
      return {
        center: {
          lng: this.navigatorInfo.coords.longitude,
          lat: this.navigatorInfo.coords.latitude,
        },
        zoom: 15,
        show: true,
        dragging: true,
      };
    },
  },
  created() {
    this.getLocation();
  },
};
</script>
 
<style scoped>
.map {
  width: 100%;
  height: 900px;
}

#container {
  overflow: hidden;
  width: 100%;
  height: 90%;
  margin: 0;
  font-family: "微软雅黑";
}
</style>


// WEBPACK FOOTER //
// src/pages/ShopNavigator.vue